// extracted by mini-css-extract-plugin
export default {"cls1":"SnackBar-cls1___1295f1af6fa479ff305","cls2":"SnackBar-cls2__d2ee8513282e528503c3 SnackBar-cls1___1295f1af6fa479ff305"};